const pending = new Map()

export function resizeTextarea(el, parent) {
  if (!pending.size) queueMicrotask(flushTextareaResizes)
  pending.set(el, parent)
}

export function flushTextareaResizes() {
  const inputs = [...pending].filter(([el, parent]) => el.isConnected && parent.isConnected)
  pending.clear()

  // Group reads and writes so mounting many inputs doesn't force a layout per input.
  const heights = inputs.map(([el]) => el.offsetHeight)
  inputs.forEach(([el, parent], i) => {
    parent.style.height = `${heights[i]}px`
    el.style.height = 'auto'
  })
  const contentHeights = inputs.map(([el]) => el.scrollHeight)
  inputs.forEach(([el, parent], i) => {
    el.style.height = `${contentHeights[i]}px`
    parent.style.height = 'auto'
  })
}
